module.exports = __webpack_public_path__ + "static/media/5.question.d336d90b.mp4";